import { useQuery } from '@tanstack/vue-query';
import { toValue, type MaybeRefOrGetter } from 'vue';
import type { Equipment } from '/@entities/equipment/equipment';
import api from '/@utilities/http';

export const queryKeys = {
  all: ['equipments'] as const,
};

const loadEquipments = () => api.get<Equipment[]>('equipments').then(({ data }) => data);

export function useEquipmentsQuery() {
  return useQuery({
    queryKey: queryKeys.all,
    queryFn: loadEquipments,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}

export function useEquipmentQuery(resourceGuid: MaybeRefOrGetter<string | null | undefined>) {
  return useQuery({
    queryKey: queryKeys.all,
    queryFn: loadEquipments,
    select: (data) => data.find((e) => e.Guid === toValue(resourceGuid)) ?? null,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}
